import { AccountEyeIcon } from './AccountEyeIcon';

/**
 * author: Michael Irigoyen
 * id 5FFF2FB6-08B2-4860-ACCF-72D614641882
 * name account-eye
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/account-eye.svg
 * tags
 * - Account / User 
 */
export const AccountViewIcon = AccountEyeIcon;
export default AccountViewIcon